import './ImageGallery.css';

import FullscreenImage from '../fullscreen-image/FullscreenImage';

import image1 from '../../assets/images/image-gallery/1.jpg';
import image2 from '../../assets/images/image-gallery/2.jpg';
import image3 from '../../assets/images/image-gallery/3.jpg';
import image4 from '../../assets/images/image-gallery/4.jpg';
import image5 from '../../assets/images/image-gallery/5.jpg';
import image6 from '../../assets/images/image-gallery/6.jpg';
import image7 from '../../assets/images/image-gallery/7.jpg';
import image8 from '../../assets/images/image-gallery/8.jpg';
import image9 from '../../assets/images/image-gallery/9.jpg';
import image10 from '../../assets/images/image-gallery/10.jpg';
import image12 from '../../assets/images/image-gallery/12.jpg';
import image13 from '../../assets/images/image-gallery/13.jpg';
import image14 from '../../assets/images/image-gallery/14.jpg';
import image15 from '../../assets/images/image-gallery/15.jpg';
import image16 from '../../assets/images/image-gallery/16.jpg';
import image17 from '../../assets/images/image-gallery/17.jpg';
import image18 from '../../assets/images/image-gallery/18.jpg';
import image19 from '../../assets/images/image-gallery/19.jpg';
import image20 from '../../assets/images/image-gallery/20.jpg';
import image21 from '../../assets/images/image-gallery/21.jpg';
import image22 from '../../assets/images/image-gallery/22.jpg';
import image23 from '../../assets/images/image-gallery/23.jpg';
import image25 from '../../assets/images/image-gallery/25.jpg';
import image26 from '../../assets/images/image-gallery/26.jpg';
import image27 from '../../assets/images/image-gallery/27.jpg';
import image28 from '../../assets/images/image-gallery/28.jpg';

export default function ImageGallery({ images }) {
  return (
    <div className='conatiner-image-gallery'>
      <div className='image-gallery-item'>
        <FullscreenImage image={image1} altText='gallery-1' />
      </div>
      <div className='image-gallery-item'>
        <FullscreenImage image={image2} altText='gallery-2' />
      </div>
      <div className='image-gallery-item'>
        <FullscreenImage image={image3} altText='gallery-3' />
      </div>
      <div className='image-gallery-item'>
        <FullscreenImage image={image4} altText='gallery-4' />
      </div>
      <div className='image-gallery-item'>
        <FullscreenImage image={image5} altText='gallery-5' />
      </div>
      <div className='image-gallery-item'>
        <FullscreenImage image={image6} altText='gallery-6' />
      </div>
      <div className='image-gallery-item'>
        <FullscreenImage image={image7} altText='gallery-7' />
      </div>
      <div className='image-gallery-item'>
        <FullscreenImage image={image8} altText='gallery-8' />
      </div>
      <div className='image-gallery-item'>
        <FullscreenImage image={image9} altText='gallery-9' />
      </div>
      <div className='image-gallery-item'>
        <FullscreenImage image={image10} altText='gallery-10' />
      </div>
      <div className='image-gallery-item'>
        <FullscreenImage image={image9} altText='gallery-11' />
      </div>
      <div className='image-gallery-item'>
        <FullscreenImage image={image12} altText='gallery-12' />
      </div>
      <div className='image-gallery-item'>
        <FullscreenImage image={image13} altText='gallery-13' />
      </div>
      <div className='image-gallery-item'>
        <FullscreenImage image={image14} altText='gallery-14' />
      </div>
      <div className='image-gallery-item'>
        <FullscreenImage image={image15} altText='gallery-15' />
      </div>
      <div className='image-gallery-item'>
        <FullscreenImage image={image16} altText='gallery-16' />
      </div>
      <div className='image-gallery-item'>
        <FullscreenImage image={image17} altText='gallery-17' />
      </div>
      <div className='image-gallery-item'>
        <FullscreenImage image={image18} altText='gallery-18' />
      </div>
      <div className='image-gallery-item'>
        <FullscreenImage image={image19} altText='gallery-19' />
      </div>
      <div className='image-gallery-item'>
        <FullscreenImage image={image20} altText='gallery-20' />
      </div>
      <div className='image-gallery-item'>
        <FullscreenImage image={image21} altText='gallery-21' />
      </div>
      <div className='image-gallery-item'>
        <FullscreenImage image={image22} altText='gallery-22' />
      </div>
      <div className='image-gallery-item'>
        <FullscreenImage image={image23} altText='gallery-23' />
      </div>
      <div className='image-gallery-item'>
        <FullscreenImage image={image28} altText='gallery-24' />
      </div>
      <div className='image-gallery-item'>
        <FullscreenImage image={image25} altText='gallery-25' />
      </div>
      <div className='image-gallery-item'>
        <FullscreenImage image={image26} altText='gallery-26' />
      </div>
      <div className='image-gallery-item'>
        <FullscreenImage image={image27} altText='gallery-27' />
      </div>
      <div className='image-gallery-item'>
        <FullscreenImage image={image28} altText='gallery-28' />
      </div>
    </div>
  );
}
